var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppliance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 37,
  fill: "none",
  viewBox: "0 0 36 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M31 7.5H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2m-27 2a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm27 6H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2m-27 2a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm1 6h26a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 24,
  y: 9.5,
  fill: "#fff",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 24,
  y: 17.5,
  fill: "#fff",
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 24,
  y: 25.5,
  fill: "#fff",
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 28,
  y: 9.5,
  fill: "#fff",
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 28,
  y: 17.5,
  fill: "#fff",
  rx: 1
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 28,
  y: 25.5,
  fill: "#fff",
  rx: 1
})));
export default SvgAppliance;